
import { Loader2 } from "lucide-react"
import { motion } from "framer-motion"
import { DocumentSearch } from "@/components/documents/DocumentSearch"
import { DocumentTable } from "@/components/documents/DocumentTable"
import { DocumentViewDialog } from "@/components/documents/DocumentViewDialog"
import { DeleteConfirmationDialog } from "@/components/documents/DeleteConfirmationDialog"
import { useDocuments } from "@/hooks/useDocuments"

export default function Documents() {
  const {
    documents,
    isLoading,
    selectedDocument,
    editedContent,
    isEditing,
    searchTerm,
    selectedDocuments,
    showDeleteAlert,
    documentsToDelete,
    setSearchTerm,
    setEditedContent,
    setSelectedDocument,
    setIsEditing,
    setShowDeleteAlert,
    handleDelete,
    handleDeleteSelected,
    confirmDeleteSelected,
    handleEdit,
    handleViewDocument,
    handleSelectDocument,
    handleSelectAll,
  } = useDocuments()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    )
  }

  return (
    <div className="container py-8 px-4 md:px-6">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="space-y-8"
      >
        <DocumentSearch 
          searchTerm={searchTerm}
          onSearchChange={setSearchTerm}
        />

        <DocumentTable 
          documents={documents}
          onView={handleViewDocument}
          onDelete={handleDelete}
          onDeleteSelected={handleDeleteSelected}
          selectedDocuments={selectedDocuments}
          onSelectDocument={handleSelectDocument}
          onSelectAll={handleSelectAll}
        />

        <DocumentViewDialog 
          document={selectedDocument}
          isEditing={isEditing}
          editedContent={editedContent}
          onClose={() => setSelectedDocument(null)}
          onEdit={() => setIsEditing(true)}
          onSave={handleEdit}
          onContentChange={setEditedContent}
        />

        <DeleteConfirmationDialog 
          open={showDeleteAlert}
          onOpenChange={setShowDeleteAlert}
          count={documentsToDelete.length}
          onConfirm={confirmDeleteSelected}
        />
      </motion.div>
    </div>
  )
}
